import { FC, useEffect, useRef, useState } from "react";
import { StatisticsObjectType } from "../caseVolumeLineChart/types";
import { BAR_CHART_OPTIONS } from "src/constants/highCharts";
import HighchartsReact from "highcharts-react-official";
import HighCharts from "highcharts";
import { PriorAuthKeys } from "src/pages/manufacturer/types";



const CustomComponentForPriorAuth: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {

  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
  const [barChartOptionPrior, setChartOptions] = useState(BAR_CHART_OPTIONS);
  const [medicalBarChartOptionPrior, setMedicalBarChartOptions] = useState(BAR_CHART_OPTIONS);
  const [pdpsbarChartOptionPrior, setPdpsChartOptionsPrior] = useState(BAR_CHART_OPTIONS);




  useEffect(() => {
    const latestChartOptions = { ...barChartOptionPrior };
    const filteredData = Object.keys(StatisticsObjectType.pharmacy_prior_auths).filter((item) => !["closed"].includes(item))
    latestChartOptions.xAxis = {
      categories: filteredData.map(label => 
        label === "unknown" ? "" : label.replace(/_/g, ' ').split(" ").map((item) => `${item.charAt(0).toUpperCase()}${item.slice(1)}`).join(" ")
      )
    };
    latestChartOptions.series = [{
      type: 'bar',
      name: 'Value',
      data: filteredData.map((value) => StatisticsObjectType.pharmacy_prior_auths[value as PriorAuthKeys] ?? 0)
    }];
    setChartOptions(latestChartOptions);

    const medicallatestChartOptions = { ...medicalBarChartOptionPrior };
    medicallatestChartOptions.xAxis = {
      categories: Object.keys(StatisticsObjectType.medical_prior_auths).map(label => 
        label === "unknown" ? "" : label.replace(/_/g, ' ').split(" ").map((item) => `${item.charAt(0).toUpperCase()}${item.slice(1)}`).join(" ")
      )
    };
    medicallatestChartOptions.series = [{
      type: 'bar',
      name: 'Value',
      data: Object.values(StatisticsObjectType.medical_prior_auths).map(value => value ?? 0),
    }];

    setMedicalBarChartOptions(medicallatestChartOptions);

    const pdpslatestChartOptions = { ...pdpsbarChartOptionPrior };
    pdpslatestChartOptions.xAxis = {
      categories: Object.keys(StatisticsObjectType.pdps)
    }
    pdpslatestChartOptions.series = [{
      type: 'bar',
      name: 'Value',
      data:Object.values(StatisticsObjectType.pdps).map(value => value ?? 0),
    }];

    setPdpsChartOptionsPrior(pdpslatestChartOptions);


    const chart = chartComponentRef.current?.chart;

    if (chart) chart.redraw();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [StatisticsObjectType]);


  return (
    <div className="row">
      <div className="col-12 col-sm-12 col-md-4">
        <div className="card">
          <div className="card-header">
            <h4 className="m-0 text-center text-primary">Medical Prior Auths</h4>
          </div>
          <div className="card-body">
            <HighchartsReact
              highcharts={HighCharts}
              options={medicalBarChartOptionPrior}
              immutable={true}
              ref={chartComponentRef}
            />
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-12 col-md-4">
        <div className="card">
          <div className="card-header">
            <h4 className="m-0 text-center text-primary">Pharmacy Prior Auths</h4>
          </div>
          <div className="card-body">
            <HighchartsReact
                highcharts={HighCharts}
                options={barChartOptionPrior}
                immutable={true}
                ref={chartComponentRef}
            />
          </div>
        </div>
      </div>
      <div className="col-12 col-sm-12 col-md-4">
        <div className="card">
          <div className="card-header">
            <h4 className="m-0 text-center text-primary">Patient Direct Purchases</h4>
          </div>
          <div className="card-body">
            <HighchartsReact
                highcharts={HighCharts}
                options={pdpsbarChartOptionPrior}
                immutable={true}
                ref={chartComponentRef}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomComponentForPriorAuth;
